<template>
    <div>
      <el-steps :active="step" finish-status="success" class="mb-2 static-css">
        <el-step title="" icon="el-icon-set-up"></el-step>
        <el-step title="" icon="el-icon-mobile-phone"></el-step>
        <el-step title="" icon="el-icon-lock"></el-step>
      </el-steps>
      <div v-if="step === 0">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">
          Seleccione el tipo de doble factor de autenticación:
        </p>
        <AccessibleElSelect
          class="mt-2"
          v-model="tipoAcceso"
          prop="tipoAcceso"
          :options="tiposOtpForAccessibleSelect"
          :withFormItem="false"
          id-prefix="otpconfigform-tipoacceso"
        />
      </div>
      <div v-else-if="step === 1 && tipoAcceso == 3">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">
          Descarge la aplicación de Microsoft Authenticator en cualquiera de las siguientes plataformas:
        </p>
        <AccessibleElSelect
          class="mt-2"
          v-model="tipoPlataforma"
          prop="tipoPlataforma"
          :options="tiposPlataformaForAccessibleSelect"
          :withFormItem="false"
          id-prefix="otpconfigform-tipoplat"
        />
        <div class="flex mt-2 w-full justify-center">
          <a v-if="tipoPlataforma == 0" href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" >
            <img :src="PlayStoreQR" alt="MicrosoftAutenticatorPlayStoreQR" class="max-h-56"/>
          </a>
          <a v-if="tipoPlataforma == 1" href="https://apps.apple.com/es/app/microsoft-authenticator/id983156458" target="_blank" >
            <img :src="AppStoreQR" alt="MicrosoftAutenticatorAppStoreQR" class="max-h-56"/>
          </a>
        </div>
      </div>
      <div v-else-if="step === 2 && tipoAcceso == 3">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">
          Escanee el siguiente código QR:
        </p>
        <div class="flex mt-2 w-full justify-center">
          <img :src="'data:image/png;base64,' + b64Qr" alt="QRCode" class="max-h-56"/>
        </div>
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200 mt-2">
          Después introduzca el código que aparece en la aplicación:
        </p>
        <el-input
          placeholder="Código "
          type="codigo"
          class="mb-2 custom__icons mt-2 static-css"
          v-model="otpLoginForm.codigo"
          maxlength='6'
          >
          <i slot="prefix" class="el-input__icon">
              <BaseIcon size="sm"  name="lock" />
          </i>
          <template v-if="otpLoginForm.codigo" slot="suffix">
            <base-clear-input-button
              aria-label="Limpiar campo de código OTP"
              @clear="otpLoginForm.codigo = ''"
            />
          </template>
        </el-input>
      </div>
      <div v-else-if="step === 2 && tipoAcceso == 2">
        <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">
          Introduzca el código que ha recibido en su correo electrónico:
        </p>
        <el-input
          placeholder="Código "
          type="codigo"
          class="mb-2 custom__icons mt-2 static-css"
          v-model="otpLoginForm.codigo"
          maxlength='6'
          >
          <i slot="prefix" class="el-input__icon">
              <BaseIcon size="sm"  name="lock" />
          </i>
          <template v-if="otpLoginForm.codigo" slot="suffix">
            <base-clear-input-button
              aria-label="Limpiar campo de código OTP"
              @clear="otpLoginForm.codigo = ''"
            />
          </template>
        </el-input>
      </div>
          <div class="flex items-center justify-end mt-4">
            <span class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
              @click="cleanToggleForms()"
              >Volver a inicio de sesión</span>
          </div>
          <div class="flex mt-4">
              <base-button
                v-if="step > 0"
                class="mr-2"
                mode="staticprimary"
                text="Volver"
                type="submit"
                :loading = "loader"
                @click="backStep()"
              />
              <base-button
                v-if="step < 2"
                :disabled="tipoAcceso == null"
                class="w-full"
                mode="staticprimary"
                :text="'Siguiente'"
                type="submit"
                :loading = "loader"
                @click="nextStep()"
              />
              <base-button
                v-else
                class="w-full"
                mode="staticprimary"
                :text="'Acceder'"
                type="submit"
                :loading = "loader"
                @click="sendCode('otpLoginForm')"
              />
          </div>
    </div>
</template>

<script>
import AppStoreQR from '@/assets/img/qrcodes/AppStoreQR2.svg'
import PlayStoreQR from '@/assets/img/qrcodes/PlayStoreQR2.svg'
import { configOTP } from '@/services/auth/configOTP'
import { generateOTP } from '@/services/auth/generateOTP'
import { TIPOS_OTP } from '@/config/tipos-otp'
import { TIPOS_PLATAFORMA } from '@/config/tipos-plataforma'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'otp-login-form',
  components: {
    AccessibleElSelect
  },
  data: function () {
    return {
      loader: false,
      step: 0,
      tipoAcceso: 3,
      tipoPlataforma: 0,
      b64Qr: '',

      PlayStoreQR: PlayStoreQR,
      AppStoreQR: AppStoreQR,

      tiposOtp: TIPOS_OTP,
      tiposPlataforma: TIPOS_PLATAFORMA,

      otpLoginForm: {
        codigo: '',
      },
    }
  },
  computed: {
    tiposOtpForAccessibleSelect () {
      return this.tiposOtp.map(item => ({
        id: item.value,
        name: item.label,
        value: item.value
      }))
    },
    tiposPlataformaForAccessibleSelect () {
      return this.tiposPlataforma.map(item => ({
        id: item.value,
        name: item.label,
        value: item.value
      }))
    }
  },
  methods: {
    cleanToggleForms () {
      this.$emit('cleanToggleForms')
    },
    backStep () {
      if (this.step === 2 && this.tipoAcceso === 2) {
        this.step--
      }
      this.step--
    },
    nextStep () {
      if (this.step === 0 && this.tipoAcceso === 2) {
        this.step++
      }
      this.enviarTipo()
      this.step++
    },
    enviarTipo: async function () {
      try {
        this.loader = true
        const tipoAcceso = this.tipoAcceso === 2 ? 'EMAIL'
          : this.tipoAcceso === 3 ? 'OTP'
            : null
        const response = await configOTP(tipoAcceso)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.generateOTP()
        }
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    },
    generateOTP: async function () {
      try {
        this.loader = true
        const response = await generateOTP()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        }
        this.b64Qr = response.Base64QR
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    },
    sendCode: async function () {
      try {
        this.loader = true
        await this.$store.dispatch('auth/checkOTPLogin', { otpCode: this.otpLoginForm.codigo })
        // await this.$store.dispatch('app/getAnnouncementsList')
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    }
  }
}
</script>
<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>

